var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('main',{staticClass:"mt-10"},[_c('van-button',{staticClass:"logout",attrs:{"block":"","round":"","type":"info"},on:{"click":_vm.logout}},[_vm._v("退出账户")])],1),_c('Footer',{attrs:{"page":"my"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }